export type Severity = 'success' | 'info' | 'failure' | 'warning';

/**
 * Represents an alert message.
 */
export type Alert = {
    severity: Severity;
    message: string;
    id: string;
};

/**
 * Represents the context type for the AlertContext.
 */
export type AlertContextType = {
    /**
     * A dictionary of alerts, where the keys are alert IDs and the values are Alert objects.
     */
    alerts: Record<string, Alert>;
    /**
     * Function to push a new alert to the alerts list.
     */
    push: (_alert: Alert) => void;
    /**
     * Function to remove an alert from the alerts list.
     */
    remove: (id: string) => void;
    /**
     * Function to remove all alerts
     */
    removeAll: () => void;
};
